import axios from 'axios';
import {
    getNewToken,
    LOCAL_STORAGE_EXPIRE_AT,
    LOCAL_STORAGE_TOKEN,
    logout,
    setAutoRedirect,
    setUserInfo
} from "../redux-store/auth";
import {ResponseStatus} from "../constants/responseStatus";
import {unwrapResult} from "@reduxjs/toolkit";

const api = axios.create({
    baseURL: "",
});

const interceptor = store => {
    api.interceptors.request.use(async request => {
        let fluxerToken = localStorage.getItem(LOCAL_STORAGE_TOKEN);
        const expireAt = localStorage.getItem(LOCAL_STORAGE_EXPIRE_AT);
        const currentDateTime = new Date();
        const expireAtDate = new Date(expireAt);

        // && !store.getState().auth.refreshTokenPending
        if ((expireAtDate < currentDateTime)) {
            const newUserData = unwrapResult(await store.dispatch(getNewToken(fluxerToken)));

            if (newUserData === null)
                return request;
            else {
                fluxerToken = newUserData.token;
                store.dispatch(setUserInfo(newUserData));
            }
        }
        request.headers.Authorization = `Bearer ${fluxerToken}`;
        return request;
    })

    api.interceptors.response.use(response => {
        return response;
    }, error => {
        if (error.response && error.response.status === ResponseStatus.UNAUTHORIZED) {
            store.dispatch(logout())
        } else if (error.response && error.response.status === ResponseStatus.INTERNAL_ERROR) {
            store.dispatch(setAutoRedirect(ResponseStatus.INTERNAL_ERROR));
        } else if (error.response && error.response.status === ResponseStatus.FORBIDDEN) {
            store.dispatch(setAutoRedirect(ResponseStatus.FORBIDDEN));
        }
        return Promise.reject(error);
    })
}
export default api;
export {interceptor};